module.exports = __webpack_public_path__ + "static/media/lboxBlanco.b9af9025.png";